<dx-popover
  (onHidden)="datesPopoverVisible = false"
  (onHiding)="resetValues()"
  [(visible)]="datesPopoverVisible"
  [hideOnOutsideClick]="true"
  [width]="590"
  [wrapperAttr]="{
    class: 'timeSelectorPopup'
  }"
  position="top"
  style="display: none;"
  target="#link1">
  <div *dxTemplate="let data = model; of: 'content'">

    <dx-radio-group
      [(value)]="typeOfDateSettings"
      [items]="typeOfDateSettingsList"
      layout="horizontal">
      <div *dxTemplate="let dateSetting of 'item'">
        <div>{{ 'DATE_SELECTION.' + dateSetting + ".TITLE" | translate }}</div>
      </div>
    </dx-radio-group>
    <div *ngIf="typeOfDateSettings === TypeOfDateSettingsEnum.FIXED_DATE" class="alarmDateContainer">
      <dx-date-box
        (valueChange)="checkStartDateValidity();"
        [(value)]="startDate"
        [max]="endDate"
        applyValueMode="instantly"
        label="{{'DATE_SELECTION.FIXED_DATE.START_DATE_LABEL' | translate}}"
        style="flex: 1 1"
        type="datetime">
        <dx-validator [validationGroup]="'fromDate'">
          <dxi-validation-rule
            [comparisonTarget]="datesPopoverEndComparison"
            [comparisonType]="'<='"
            message="{{'DATE_SELECTION.FIXED_DATE.START_DATE_ERROR_MSG' | translate}}"
            type="compare"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-date-box>
      <dx-date-box
        (valueChange)="checkStartDateValidity();"
        [(value)]="endDate"
        applyValueMode="instantly"
        label="{{'DATE_SELECTION.FIXED_DATE.END_DATE_LABEL' | translate}}"
        style="flex: 1 1"
        type="datetime">
      </dx-date-box>

    </div>

    <div *ngIf="typeOfDateSettings === TypeOfDateSettingsEnum.REALTIME" class="alarmDateContainer">

      <!-- ******************************** -->
      <!-- Time Value                       -->
      <!-- ******************************** -->

      <dx-number-box
        [(value)]="realtimeValue"
        [max]="9999"
        [min]="1"
        [showSpinButtons]="true"
        [step]="1"
        label="{{ 'DATE_SELECTION.REALTIME.TIME_VALUE' | translate }}"
        style="flex: 1 1">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dx-number-box>

      <!-- ******************************** -->
      <!-- Time Units                       -->
      <!-- ******************************** -->

      <dx-select-box
        [(value)]="realTimeUnit"
        [dataSource]="telemetrySearchUnitValues"
        [displayExpr]="getAcquisitionCronLabel"
        [width]="'100%'"
        label="{{ 'DATE_SELECTION.REALTIME.TIME_UNIT' | translate }}"
        style="flex: 2 1">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dx-select-box>


    </div>

    <div *ngIf="typeOfDateSettings === TypeOfDateSettingsEnum.LAST_EVENTS" class="alarmDateContainer">

      <dx-number-box [(value)]="lastEventsNumber" [max]="1000" [min]="1" [showSpinButtons]="true" [step]="1"
                     [width]="'100%'"
                     label="{{ 'DATE_SELECTION.LAST_EVENTS.EVENTS_NUMBER' | translate }}"></dx-number-box>

    </div>

    <div class="rowFlexContent" style="justify-content: end; margin-top: 10px">
      <dx-button
        (onClick)="datesPopoverVisible = false"
        stylingMode="text"
        text="{{'BUTTONS.CANCEL' | translate}}">
      </dx-button>
      <div class="flexFill"></div>
      <dx-button
        (onClick)="applyDataChanges(); datesPopoverVisible = false"
        [disabled]="(typeOfDateSettings === TypeOfDateSettingsEnum.FIXED_DATE && !dateIsValid)"
        [elementAttr]="{class:'redButton'}"
        [icon]="'check'"
        text="{{'BUTTONS.APPLY' | translate}}" type="default">
      </dx-button>
    </div>
  </div>
</dx-popover>


<dx-button
  (onClick)="datesPopoverVisible = !datesPopoverVisible"
  [elementAttr]="{class:'outlinedRedButton'}"
  hint="{{'BUTTONS.HINTS.DATE_SELECTION' | translate}}"
  id="link1"
  type="default">
  <i class="vr-ic_fluent_clock_24_regular"></i>
  <div *ngIf="!appService.isMediumScreen()" [innerHtml]="printDateSelectionText()" class="datesSelectionText"></div>
</dx-button>
